import { Navigate } from 'react-router-dom';

import { useAuth } from '@/features/auth/AuthProvider';
import { getDefaultRoutePath } from './routeRegistry';

export function DefaultRouteRedirect() {
  const { currentUser } = useAuth();

  return <Navigate to={getDefaultRoutePath(currentUser)} replace />;
}
